import React from 'react';

import {SvgIcon} from './SvgIcon';

const ArrowBackIcon: SvgIcon = ({width = 20, height = 20, classes}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <g id="Group 418">
      <path
        id="icons / arrow_back.icon"
        fill="currentColor"
        d="M5.3866 5.42053L5.34271 6.95745L13.2684 6.7311L13.0421 14.6568L14.579 14.6129L14.8492 5.15028L5.3866 5.42053Z"
      />
      <path
        id="Vector 197"
        d="M13.435 6.56742L4.59619 15.4062"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

export default ArrowBackIcon;
